// extracted by mini-css-extract-plugin
module.exports = {"dashboardNav":"DashboardNav_dashboardNav__1gdPo","hide":"DashboardNav_hide__3IX2s"};